export default __webpack_public_path__ + "static/media/cahtlogobtp.514acf7281f10ff0a72515b7c4d0051d.svg";